'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagKnAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 13.3333L28 0H0V13.3333Z",
          fill: "#1EC160"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 20H28V6.66667L0 20Z",
          fill: "#DF2A40"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9 20L28 8.5L28 0H19.5L0 12V20L9 20Z",
          fill: "#FFD956"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4 20L28 5L28 0H24L0 15V20L4 20Z",
          fill: "#262626"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M20.3092 7.79741L19.3638 9.29477L18.7504 7.63357L17.0342 7.19715L18.4245 6.1004L18.3092 4.33331L19.7819 5.31668L21.4269 4.66099L20.9468 6.3655L22.0787 7.72734L20.3092 7.79741Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.64273 14.2641L8.69733 15.7615L8.08389 14.1003L6.36767 13.6638L7.75801 12.5671L7.64273 10.8L9.11544 11.7834L10.7604 11.1277L10.2803 12.8322L11.4122 14.194L9.64273 14.2641Z",
          fill: "white"
        }
      )
    ]
  }
);
const VpFlagKnAsset = forwardRef(FlagKnAsset);

export { VpFlagKnAsset as default };
